import { Component } from '@angular/core';

@Component({
  selector: 'app-scc-payment',
  templateUrl: './scc-payment.component.html',
  styleUrls: ['./scc-payment.component.scss']
})
export class SccPaymentComponent {
  ready = false;
}
